import React from "react";
import { HiOutlineViewfinderCircle } from "react-icons/hi2";

interface ButtonProps {
  label?: string;
  type?: "submit";
  onClick?: () => void;
  textPosition?: "left" | "center" | "right";
  width?: "full" | "1/3" | "11/12" | "100px";
  variant?: "btn-primary" | "btn-secondary" | "btn-danger";
  size?: "small" | "medium" | "large";
  rounded?: boolean;
  borderBottom?: boolean;
  color?: string;
  gray?: boolean;
  isTrack?: boolean;
  isActive?: boolean;
  customColor?: any;
  isProfile?: boolean;
}

const Button = ({
  label,
  type,
  textPosition = "center",
  width = "full",
  rounded = false,
  variant = "btn-primary",
  size = "medium",
  borderBottom = false,
  gray = false,
  color,
  isTrack,
  isActive,
  customColor,
  isProfile,
  onClick,
}: ButtonProps) => {
  const getButtonClasses = () => {
    let baseClasses =
      "font-medium transition-colors duration-300 focus:outline-none h-[30px] shadow-md font-sans";

    const activeClasses = isActive
      ? "bg-red-500 text-white cursor-default "
      : "";

    switch (variant) {
      case "btn-primary":
        return `${baseClasses} bg-blue-500 text-white ${
          isActive ? "" : "hover:bg-blue-600"
        } disabled:bg-blue-300 disabled:hover:bg-blue-300 ${activeClasses}`;
      case "btn-secondary":
        return `${baseClasses} bg-gray-300 text-gray-700 ${
          isActive ? "" : "hover:bg-slate-200 hover:text-black"
        } disabled:bg-gray-100 disabled:hover:bg-gray-100 ${activeClasses}`;
      case "btn-danger":
        return `${baseClasses} bg-red-600 text-white disabled:bg-red-300 disabled:hover:bg-red-300  ${activeClasses}`;
      default:
        return baseClasses;
    }
  };

  const getButtonSize = () => {
    switch (size) {
      case "small":
        return "px-2 py-1 text-custom-micro";
      case "large":
        return "px-6 py-1 text-custom-micro";
      case "medium":
        return "px-4 py-1 text-custom-micro";
      default:
        return "px-4 py-2";
    }
  };

  const baseClasses = "p-3 cursor-pointer pl-2";
  const textPositionClass = `text-${textPosition}`;
  const widthClass =
    width === "full"
      ? "w-full"
      : width === "1/3"
      ? "w-1/3"
      : width === "11/12"
      ? "w-11/12"
      : width === "100px"
      ? "w-[100px]"
      : "";

  return (
    <button
      className={`${getButtonClasses()} ${getButtonSize()} ${baseClasses} ${textPositionClass} ${widthClass} ${
        rounded ? "rounded-md" : ""
      } ${borderBottom ? "border-b border-slate-300" : ""} ${
        customColor
          ? `hover:scale-105 transition-all duration-300`
          : `hover:bg-custom-default-hover hover:shadow-lg   hover:shadow-red-500/40`
      }`}
      onClick={!isActive ? onClick : undefined}
      style={{ backgroundColor: isProfile ? "" : customColor }}
      type={type}
    >
      {isTrack ? (
        <span className="flex justify-center gap-2 items-center">
          <HiOutlineViewfinderCircle className="text-custom-micro" /> {label}
        </span>
      ) : (
        <>{label}</>
      )}
    </button>
  );
};

export default Button;
